(() => {
  'use strict';
  const header = document.querySelector('.dama-header');
  const triggers = [...document.querySelectorAll('[data-dama-menu]')];
  const plKeyboardMenu = window.location.origin === 'https://damacouture.pl'
    && ['pl', 'pl-pl'].includes((document.documentElement.lang || '').toLowerCase());
  function closeMenus() {
    triggers.forEach(button => {
      button.setAttribute('aria-expanded', 'false');
      const panel = document.getElementById(button.dataset.damaMenu);
      if (panel) panel.hidden = true;
    });
  }
  function openMenu(button) {
    closeMenus();
    const panel = document.getElementById(button.dataset.damaMenu);
    if (panel) { panel.hidden = false; button.setAttribute('aria-expanded', 'true'); }
  }
  triggers.forEach(button => {
    button.addEventListener('click', () => button.getAttribute('aria-expanded') === 'true' ? closeMenus() : openMenu(button));
    button.closest('.dama-nav-group')?.addEventListener('mouseenter', () => {
      if (matchMedia('(hover: hover) and (min-width: 900px)').matches) openMenu(button);
    });
  });
  header?.addEventListener('mouseleave', () => {
    if (!plKeyboardMenu) { closeMenus(); return; }
    const focused = document.activeElement;
    const focusInOpenMenu = triggers.some(button => {
      if (button.getAttribute('aria-expanded') !== 'true') return false;
      const panel = document.getElementById(button.dataset.damaMenu);
      return focused === button || Boolean(panel?.contains(focused));
    });
    if (!focusInOpenMenu) closeMenus();
  });
  document.querySelectorAll('[data-dama-menu-close]').forEach(button => button.addEventListener('click', () => {
    const active = triggers.find(t => t.getAttribute('aria-expanded') === 'true'); closeMenus(); active?.focus();
  }));
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    if (!plKeyboardMenu) { closeMenus(); return; }
    const returnTrigger = triggers.find(button => {
      if (button.getAttribute('aria-expanded') !== 'true') return false;
      return document.getElementById(button.dataset.damaMenu)?.contains(document.activeElement);
    });
    closeMenus();
    returnTrigger?.focus({preventScroll: true});
  });
  document.addEventListener('click', event => { if (header && !header.contains(event.target)) closeMenus(); });
  document.addEventListener('focusin', event => { if (header && !header.contains(event.target)) closeMenus(); });

  const localeDestinations = {
    es: { key: 'es', host: 'damacouture.es' },
    fr: { key: 'fr', host: 'damacouture.fr' },
    it: { key: 'it', host: 'damacouture.it' },
    de: { key: 'de', host: 'damacouture.de' },
    pl: { key: 'pl-PL', host: 'damacouture.pl' },
    'pl-pl': { key: 'pl-PL', host: 'damacouture.pl' },
    en: { key: 'en', host: 'damacouture.com' },
    'en-gb': { key: 'en-GB', host: 'damacouture.co.uk' }
  };
  function syncLocaleLinks() {
    let urls = {};
    try { urls = JSON.parse(document.getElementById('dama-locale-urls')?.textContent || '{}').urls || {}; } catch (_) {}
    document.querySelectorAll('[data-dama-locale]').forEach(link => {
      const destination = localeDestinations[link.dataset.damaLocale.toLowerCase()];
      if (!destination) return;
      delete link.dataset.damaResourceHref;
      link.href = `https://${destination.host}/`;
      try {
        // DAMA 10.10.2026: dama-hreflang podaje polski klucz jako "pl" (do 10.10 "pl-PL") - przyjmij oba.
        const url = new URL(urls[destination.key] || urls[link.dataset.damaLocale]);
        if (url.protocol === 'https:' && url.hostname === destination.host && !url.username && !url.password && !url.port) link.href = url.href;
      } catch (_) {}
      const activeTheme = window.Shopify?.theme;
      if (['unpublished', 'development'].includes(activeTheme?.role) && /^\d+$/.test(String(activeTheme.id))) {
        const previewUrl = new URL(link.href);
        previewUrl.searchParams.set('preview_theme_id', String(activeTheme.id));
        link.href = previewUrl.href;
      }
    });
  }
  syncLocaleLinks();
  document.addEventListener('dama:locale-routing-updated', syncLocaleLinks);

  function sectionLoader(mount, sectionId, selector, requiredSelectors, mounted) {
    let loaded = null;
    let request = null;
    return function load() {
      if (loaded) return Promise.resolve(loaded);
      if (request) return request;
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 10000);
      const url = new URL(window.location.href);
      url.hash = '';
      url.searchParams.delete('sections');
      url.searchParams.set('section_id', sectionId);
      request = fetch(url.href, { credentials: 'same-origin', signal: controller.signal })
        .then(response => {
          if (!response.ok || (response.url && new URL(response.url).origin !== url.origin)) throw new Error('Section unavailable');
          return response.text();
        })
        .then(html => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const section = doc.getElementById(`shopify-section-${sectionId}`);
          const content = section?.querySelector(selector);
          if (!content || requiredSelectors.some(required => !content.querySelector(required))) throw new Error('Incomplete section');
          if (content.dataset.damaOverlayTheme !== mount.dataset.damaOverlayTheme) throw new Error('Section theme mismatch');
          section.querySelectorAll('script').forEach(script => script.remove());
          mount.replaceChildren(...[...section.childNodes].map(node => document.importNode(node, true)));
          loaded = mount.querySelector(selector);
          mounted?.(loaded);
          return loaded;
        })
        .finally(() => { clearTimeout(timer); request = null; });
      return request;
    };
  }
  const searchMount = document.querySelector('[data-dama-search-lazy]');
  let searchOpening = false;
  let searchIntent = 0;
  const loadSearch = searchMount && sectionLoader(searchMount, 'search', '.dama-search', ['input[type="search"]', 'form', '[data-search-toggle]'], () => {
    document.dispatchEvent(new CustomEvent('dama:search-ready'));
  });
  if (loadSearch) {
    document.addEventListener('click', async event => {
      const button = event.target.closest('[data-search-toggle]');
      if (!button || searchMount.querySelector('.dama-search') || searchOpening) return;
      searchOpening = true;
      const intent = ++searchIntent;
      button.setAttribute('aria-busy', 'true');
      try {
        await loadSearch();
        if (intent === searchIntent) button.click();
      } catch (_) {
        if (intent === searchIntent) window.location.assign(searchMount.dataset.damaSearchUrl);
      } finally {
        searchOpening = false;
        button.removeAttribute('aria-busy');
      }
    });
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && searchOpening) searchIntent++;
    });
  }

  document.addEventListener('keydown', event => {
    const searchPanel = document.querySelector('.dama-search');
    if (!searchPanel?.classList.contains('search--show')) return;
    const focusable = [...searchPanel.querySelectorAll('button,input,a[href]')].filter(node => !node.disabled && node.getClientRects().length);
    if (event.key === 'Escape') {
      searchPanel.querySelector('[data-search-toggle]')?.click();
      document.querySelector('.dama-header [data-search-toggle]')?.focus();
    }
    if (event.key === 'Tab' && focusable.length) {
      const first = focusable[0], last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {event.preventDefault();last.focus();}
      else if (!event.shiftKey && document.activeElement === last) {event.preventDefault();first.focus();}
    }
  });

  // DAMA 10.10.2026: ukryty baner Shopify linkuje do damacouture.com/<jezyk>/policies/... (404 na .de i .pl) - kieruj go do polityki tej domeny.
  const policyHref = document.querySelector('.dama-dialog__privacy')?.getAttribute('href') || document.querySelector('[data-dama-privacy-url]')?.dataset.damaPrivacyUrl || '/policies/privacy-policy';
  const fixShopifyPolicyLink = () => { const link = document.getElementById('shopify-pc__banner__body-policy-link'); if (link) link.href = policyHref; return Boolean(link); };
  if (!fixShopifyPolicyLink()) { const policyObserver = new MutationObserver(() => { if (fixShopifyPolicyLink()) policyObserver.disconnect(); }); policyObserver.observe(document.body, { childList: true, subtree: true }); setTimeout(() => policyObserver.disconnect(), 10000); }

  const banner = document.querySelector('.dama-cookie-banner');
  const cookieMount = document.querySelector('[data-dama-cookie-settings-lazy]');
  let dialog = document.getElementById('dama-cookie-settings');
  if (!banner || (!dialog && !cookieMount) || !window.Shopify) return;
  const categories = ['preferences', 'analytics', 'marketing'];
  let controls = [];
  let error;
  const loadError = document.querySelector('[data-dama-consent-load-error]');
  let privacy;
  let pendingOpen = false;
  let settingsIntent = 0;
  let saving = false;
  function setRow(control, enabled) {
    control.setAttribute('aria-checked', String(enabled));
    const state = control.querySelector('.dama-consent-row__state');
    state.textContent = enabled ? state.dataset.on : state.dataset.off;
  }
  function sync() {
    const consent = privacy?.currentVisitorConsent() || {};
    controls.forEach(control => setRow(control, consent[control.dataset.damaConsentCategory] === 'yes'));
  }
  function bindSettings(node) {
    dialog = node;
    controls = [...dialog.querySelectorAll('[data-dama-consent-category]')];
    error = dialog.querySelector('.dama-consent-error');
    controls.forEach(control => control.addEventListener('click', () => setRow(control, control.getAttribute('aria-checked') !== 'true')));
    dialog.querySelector('[data-dama-consent-save]')?.addEventListener('click', () => save(Object.fromEntries(controls.map(control => [control.dataset.damaConsentCategory, control.getAttribute('aria-checked') === 'true']))));
    sync();
  }
  if (dialog) bindSettings(dialog);
  const loadSettings = cookieMount && sectionLoader(cookieMount, 'dama-cookie-settings', '#dama-cookie-settings', ['[data-dama-consent-category="preferences"]', '[data-dama-consent-category="analytics"]', '[data-dama-consent-category="marketing"]', '[data-dama-consent-save]', '.dama-consent-error'], bindSettings);
  async function openSettings(event) {
    const trigger = event?.currentTarget;
    const intent = ++settingsIntent;
    pendingOpen = true;
    trigger?.setAttribute('aria-busy', 'true');
    if (loadError) loadError.hidden = true;
    try {
      if (!dialog) await loadSettings();
      if (intent !== settingsIntent) return;
      if (!privacy) return;
      pendingOpen = false;
      sync(); error.hidden = true; if (!dialog.open) dialog.showModal();
    } catch (_) {
      if (intent !== settingsIntent) return;
      pendingOpen = false;
      banner.hidden = false;
      if (loadError) loadError.hidden = false;
      trigger?.focus();
    } finally {
      trigger?.removeAttribute('aria-busy');
    }
  }
  document.querySelectorAll('[data-dama-consent-open]').forEach(button => button.addEventListener('click', openSettings));
  document.addEventListener('keydown', event => {
    if (cookieMount && event.key === 'Escape' && pendingOpen) { settingsIntent++; pendingOpen = false; }
  });
  function save(values) {
    if (!privacy || saving) return;
    settingsIntent++; pendingOpen = false;
    saving = true;
    if (error) error.hidden = true;
    if (loadError) loadError.hidden = true;
    const buttons = [...document.querySelectorAll('[data-dama-consent-save],[data-dama-consent-all],[data-dama-consent-necessary]')];
    buttons.forEach(button => { button.disabled = true; });
    const finish = failed => {
      saving = false; buttons.forEach(button => { button.disabled = false; });
      if (failed) {
        if (dialog) { if (!dialog.open) dialog.showModal(); error.hidden = false; }
        else { banner.hidden = false; if (loadError) loadError.hidden = false; }
        return;
      }
      banner.hidden = true;
      dialog?.close();
    };
    try {
      privacy.setTrackingConsent(values, result => finish(Boolean(result?.error)));
    } catch (_) { finish(true); }
  }
  document.querySelectorAll('[data-dama-consent-all]').forEach(button => button.addEventListener('click', () => save(Object.fromEntries(categories.map(key => [key, true])))));
  document.querySelectorAll('[data-dama-consent-necessary]').forEach(button => button.addEventListener('click', () => save(Object.fromEntries(categories.map(key => [key, false])))));
  function ready() {
    privacy = window.Shopify.customerPrivacy;
    if (!privacy) return;
    sync();
    function updateBanner() {
      const consent = privacy.currentVisitorConsent();
      const choiceRecorded = categories.every(category => consent[category] === 'yes' || consent[category] === 'no');
      banner.hidden = !privacy.shouldShowBanner() || choiceRecorded;
    }
    updateBanner();
    document.documentElement.classList.add('dama-consent-ready');
    document.addEventListener('visitorConsentCollected', () => { sync(); updateBanner(); });
    if (pendingOpen) openSettings();
  }
  if (window.Shopify.customerPrivacy) ready();
  else window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], apiError => {
    if (!apiError) ready();
  });

})();
